import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import ReactSelect from 'react-select';
import { getAutomationAuditService } from '../../services/campersServices';
import { getAllPrgramWithId } from '../../services/programService';
import PaginatedComponent from '../common/Pagination/PaginationComponent';
import { getTriggerType } from '../../helper';

const MESSAGE_TYPE_LABEL = { 1: 'SMS', 2: 'App Message', 3: 'Email' };
const LIMIT = 10;

const RECEIVER_TYPE_LABEL = {
    1: 'Overnight Campers',
    2: 'Commuter Campers',
    3: 'Campers with Additional Experience',
    4: 'Campers without Additional Experience',
};

const getAuditTriggerLabel = (execution) => {
    let { trigger, triggerType, totalDays } = execution.automationPayload;
    if ((trigger === 5 || trigger === 11) && !triggerType) return '—';
    return getTriggerType(trigger, totalDays, triggerType) || '—';
};

const extractBodyParts = (html) => {
    const styleMatch = html.match(/<body[^>]*style="([^"]*)"/i);
    const contentMatch = html.match(/<body[^>]*>([\s\S]*)<\/body>/i);
    return {
        style: styleMatch ? styleMatch[1] : '',
        content: contentMatch ? contentMatch[1] : html,
    };
};

const parseInlineStyle = (styleStr) => {
    if (!styleStr) return {};
    return styleStr.split(';').reduce((acc, rule) => {
        const [prop, val] = rule.split(':');
        if (prop && val) {
            const camel = prop.trim().replace(/-([a-z])/g, (_, c) => c.toUpperCase());
            acc[camel] = val.trim();
        }
        return acc;
    }, {});
};

const AutomationAudits = (props) => {
    const history = useHistory();
    const automationId = props.match.params.automationId;
    const automationName = props.location.state?.automationName || 'Automation';

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [recipientsExecution, setRecipientsExecution] = useState(null);
    const [previewRecipient, setPreviewRecipient] = useState(null);

    const [programsList, setProgramsList] = useState([]);
    const [showFilter, setShowFilter] = useState(false);

    const [draftProgram, setDraftProgram] = useState(null);
    const [draftStartDate, setDraftStartDate] = useState('');
    const [draftEndDate, setDraftEndDate] = useState('');

    const [filterProgram, setFilterProgram] = useState(null);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    useEffect(() => {
        if (!props.campCode) return;
        getAllPrgramWithId(`?campCode=${props.campCode}`).then(res => {
            if (res?.data?.statusCode) {
                setProgramsList(res.data.responseData.result);
            }
        });
    }, [props.campCode]);

    const fetchAudits = useCallback(() => {
        setLoading(true);
        let query = `?automationId=${automationId}&page=${page - 1}&limit=${LIMIT}`;
        if (filterProgram) query += `&programId=${filterProgram.value}`;
        if (startDate) query += `&startDate=${startDate}`;
        if (endDate) query += `&endDate=${endDate}`;
        getAutomationAuditService(query).then(res => {
            setLoading(false);
            if (res?.data?.statusCode) {
                setData(res.data.responseData?.data || []);
                setTotalCount(res.data.responseData?.pagination?.total || 0);
            }
        }).catch(() => setLoading(false));
    }, [automationId, page, filterProgram, startDate, endDate]);

    const handleApplyFilter = () => {
        setFilterProgram(draftProgram);
        setStartDate(draftStartDate);
        setEndDate(draftEndDate);
        setPage(1);
        setShowFilter(false);
    };

    const handleClearFilter = () => {
        setDraftProgram(null);
        setDraftStartDate('');
        setDraftEndDate('');
        setFilterProgram(null);
        setStartDate('');
        setEndDate('');
        setPage(1);
        setShowFilter(false);
    };

    useEffect(() => {
        fetchAudits();
    }, [fetchAudits]);

    const preview = previewRecipient ? extractBodyParts(previewRecipient.html) : null;

    return (
        <div className="body_container">
            <div className="container">
                <div className="d-flex align-items-center justify-content-between page_card_header">
                    <h4>Automation Audit</h4>
                </div>

                <div className='inner_inbox_page'>
                    <div className="d-flex align-items-center mb-3">
                        <span className="btn btn-primary btn-sm me-3" onClick={() => history.push('/inbox')}>&#8592; Back</span>
                        <h6 className="mb-0">Audit: <b>{automationName}</b></h6>
                    </div>

                    <div className="d-flex justify-content-end mb-3" style={{ position: 'relative' }}>
                        <button
                            className="btn btn-primary btn-sm d-flex align-items-center gap-2"
                            onClick={() => setShowFilter(prev => !prev)}>
                            <i className="icon-filter" /> Filter
                            {(filterProgram || startDate || endDate) && (
                                <span className="badge bg-light text-dark ms-1" style={{ fontSize: '11px' }}>
                                    {[filterProgram, startDate, endDate].filter(Boolean).length}
                                </span>
                            )}
                        </button>

                        {showFilter && (
                            <div style={{
                                position: 'absolute', top: '110%', right: 0, zIndex: 99,
                                background: '#fff', border: '1px solid #ddd', borderRadius: '10px',
                                padding: '20px', width: '320px',
                                boxShadow: '0 4px 16px rgba(0,0,0,0.12)'
                            }}>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Execution Start Date</label>
                                    <div className="d-flex align-items-center gap-2">
                                        <input
                                            type="date"
                                            className="form-control form-control-sm"
                                            placeholder="Start date"
                                            value={draftStartDate}
                                            onChange={e => setDraftStartDate(e.target.value)} />
                                        <span style={{ color: '#888' }}>—</span>
                                        <input
                                            type="date"
                                            className="form-control form-control-sm"
                                            placeholder="End date"
                                            value={draftEndDate}
                                            onChange={e => setDraftEndDate(e.target.value)} />
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <label className="form-label fw-semibold">Program Name</label>
                                    <ReactSelect
                                        placeholder="Select"
                                        value={draftProgram}
                                        isClearable
                                        classNamePrefix="cm_select"
                                        onChange={e => setDraftProgram(e)}
                                        options={programsList.map(p => ({ label: p.programName, value: p._id }))} />
                                </div>

                                <div className="d-flex gap-2">
                                    <button
                                        className="btn btn-secondary btn-sm flex-fill rounded-pill"
                                        onClick={handleClearFilter}>
                                        Clear All
                                    </button>
                                    <button
                                        className="btn btn-primary btn-sm flex-fill rounded-pill"
                                        onClick={handleApplyFilter}>
                                        Apply Filter
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    {loading ? (
                        <div className="text-center py-4">Loading...</div>
                    ) : data.length === 0 ? (
                        <div className="text-center py-4">No audit records found.</div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Executed At</th>
                                        <th>Program(s)</th>
                                        <th>Trigger</th>
                                        <th>Receiver Type</th>
                                        <th>Recipients</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((execution, idx) => (
                                        <tr key={execution._id}>
                                            <td>{idx + 1 + (page - 1) * LIMIT}</td>
                                            <td>{execution.executedAt ? moment(execution.executedAt).format('DD MMM, YYYY HH:mm') : '—'}</td>
                                            <td>{(execution.programNames || []).join(', ') || '—'}</td>
                                            <td>{getAuditTriggerLabel(execution)}</td>
                                            <td>{RECEIVER_TYPE_LABEL[execution.automationPayload.receiverType] || '—'}</td>
                                            <td>
                                                <span
                                                    className="btn btn-primary btn-sm"
                                                    onClick={() => history.push({
                                                        pathname: `/automation-audit/recipients/${execution._id}`,
                                                        state: { 
                                                            executionDate: execution.executedAt ? moment(execution.executedAt).format('DD MMM, YYYY HH:mm') : '' 
                                                        }
                                                    })}
                                                >
                                                    View Recipients ({execution.recipientCount ?? 0})
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {totalCount > LIMIT && (
                        <div className="d-flex justify-content-center mt-4">
                            <PaginatedComponent
                                activePage={page}
                                itemsCountPerPage={LIMIT}
                                totalItemsCount={totalCount}
                                pageRangeDisplayed={4}
                                onPageChange={setPage} />
                        </div>
                    )}
                </div>
            </div>

            {/* Recipients modal */}
            <Modal
                size="lg"
                show={!!recipientsExecution}
                dialogClassName="remove_header_line"
                animation={false}
                centered>
                <Modal.Header>
                    <Modal.Title>
                        Recipients &mdash; {recipientsExecution?.executedAt ? moment(recipientsExecution.executedAt).format('DD MMM, YYYY HH:mm') : ''}
                    </Modal.Title>
                    <span className="modal_close" onClick={() => setRecipientsExecution(null)}><i className="icon-cross" /></span>
                </Modal.Header>
                <Modal.Body>
                    <table className="table table-bordered mb-0">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>User Name</th>
                                <th>Message Type</th>
                                <th>Content</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(recipientsExecution?.recipients || []).map((r, i) => (
                                <tr key={r._id || i}>
                                    <td>{i + 1}</td>
                                    <td>{r.userName || '—'}</td>
                                    <td>{MESSAGE_TYPE_LABEL[r.messageType] || r.messageType || '—'}</td>
                                    <td>
                                        {r.html
                                            ? <span className="btn btn-primary btn-sm" onClick={() => setPreviewRecipient(r)}>View</span>
                                            : '—'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Modal.Body>
            </Modal>

            {/* Email preview modal */}
            <Modal
                size="lg"
                show={!!previewRecipient}
                dialogClassName="remove_header_line"
                animation={false}
                centered>
                <Modal.Header>
                    <Modal.Title>
                        {previewRecipient?.userName} &mdash; {previewRecipient?.subject || 'Email Preview'}
                    </Modal.Title>
                    <span className="modal_close" onClick={() => setPreviewRecipient(null)}><i className="icon-cross" /></span>
                </Modal.Header>
                <Modal.Body style={{ padding: 0 }}>
                    {preview && (
                        <div
                            style={{ ...parseInlineStyle(preview.style), maxHeight: '520px', overflowY: 'auto', padding: '0' }}
                            dangerouslySetInnerHTML={{ __html: preview.content }}
                        />
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};

const mapStateToProps = state => ({
    campCode: state.user.userProfile.campCode,
});

export default connect(mapStateToProps)(AutomationAudits);
